<div class="notification-badge" [class.large-number]="largeNumber$ | async">
  {{ totalNotificationView$ | async }}
</div>
